export default __webpack_public_path__ + "static/media/dark-logo.602bb5c3.png";